import type { ReactNode } from "react";
import useTranslation from "../../../client/hooks/useTranslation";
import { getMoodEmoji, getMoodLabel, getPerformanceColor, getPerformanceLabel } from "../../../trading-sessions/sessionUtils";
import { useLiteData } from "../../data/LiteDataProvider";

// Petites pièces partagées par la liste et le détail des sessions.

export function Chip({ children, className = "", title }: { children: ReactNode; className?: string; title?: string }) {
  return (
    <span title={title} className={`inline-flex items-center gap-1 rounded-full bg-muted px-2.5 py-0.5 text-xs font-medium text-muted-foreground whitespace-nowrap ${className}`}>
      {children}
    </span>
  );
}

export function MoodChip({ mood }: { mood: string | null | undefined }) {
  const t = useTranslation();
  if (!mood) return null;
  return <Chip className="text-foreground">{getMoodEmoji(mood)} {getMoodLabel(mood, t)}</Chip>;
}

export function PerfChip({ performance }: { performance: string | null | undefined }) {
  const t = useTranslation();
  if (!performance) return null;
  return <Chip className={getPerformanceColor(performance)}>{getPerformanceLabel(performance, t)}</Chip>;
}

/** Durée en minutes au format du Lite ; tiret quand elle est inconnue. */
export function useDurationLabel() {
  const { fmt } = useLiteData();
  return (minutes: number | null | undefined) => (minutes && minutes > 0 ? fmt.duration(minutes * 60_000) : "-");
}

/** Point rouge pulsé : une session tourne. */
export function LiveDot() {
  return (
    <span className="relative flex h-2.5 w-2.5 shrink-0">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pnlNegative opacity-75" />
      <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-pnlNegative" />
    </span>
  );
}
